import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _68e9467e = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _1e8803d4 = () => interopDefault(import('../../../pages/councils/index.vue' /* webpackChunkName: "pages/councils/index" */))
const _462f790c = () => interopDefault(import('../../../pages/disclaimer.vue' /* webpackChunkName: "pages/disclaimer" */))
const _2e76bacc = () => interopDefault(import('../../../pages/discourse.vue' /* webpackChunkName: "pages/discourse" */))
const _dcc3ec64 = () => interopDefault(import('../../../pages/donate.vue' /* webpackChunkName: "pages/donate" */))
const _b6091ef4 = () => interopDefault(import('../../../pages/donated.vue' /* webpackChunkName: "pages/donated" */))
const _f5452e48 = () => interopDefault(import('../../../pages/donations-this-month.vue' /* webpackChunkName: "pages/donations-this-month" */))
const _044bd1c0 = () => interopDefault(import('../../../pages/engage.vue' /* webpackChunkName: "pages/engage" */))
const _b153ab4a = () => interopDefault(import('../../../pages/find/index.vue' /* webpackChunkName: "pages/find/index" */))
const _4f662882 = () => interopDefault(import('../../../pages/forgot.vue' /* webpackChunkName: "pages/forgot" */))
const _32fec612 = () => interopDefault(import('../../../pages/forum.vue' /* webpackChunkName: "pages/forum" */))
const _517e8986 = () => interopDefault(import('../../../pages/giftaid.vue' /* webpackChunkName: "pages/giftaid" */))
const _5ba5d1b3 = () => interopDefault(import('../../../pages/give/index.vue' /* webpackChunkName: "pages/give/index" */))
const _62df8940 = () => interopDefault(import('../../../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _1318505c = () => interopDefault(import('../../../pages/how-it-works.vue' /* webpackChunkName: "pages/how-it-works" */))
const _2435d9b4 = () => interopDefault(import('../../../pages/isochrones.vue' /* webpackChunkName: "pages/isochrones" */))
const _c32a9416 = () => interopDefault(import('../../../pages/jobs.vue' /* webpackChunkName: "pages/jobs" */))
const _5b9aa421 = () => interopDefault(import('../../../pages/livemap.vue' /* webpackChunkName: "pages/livemap" */))
const _21e59c44 = () => interopDefault(import('../../../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _19bd79a9 = () => interopDefault(import('../../../pages/merge.vue' /* webpackChunkName: "pages/merge" */))
const _39a002fe = () => interopDefault(import('../../../pages/mobile.vue' /* webpackChunkName: "pages/mobile" */))
const _1a27353b = () => interopDefault(import('../../../pages/modtools/index.vue' /* webpackChunkName: "pages/modtools/index" */))
const _38498996 = () => interopDefault(import('../../../pages/mydata.vue' /* webpackChunkName: "pages/mydata" */))
const _28434d58 = () => interopDefault(import('../../../pages/myposts.vue' /* webpackChunkName: "pages/myposts" */))
const _5b911dec = () => interopDefault(import('../../../pages/norfolk.vue' /* webpackChunkName: "pages/norfolk" */))
const _2d5a7eb9 = () => interopDefault(import('../../../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _008a4ef1 = () => interopDefault(import('../../../pages/promote.vue' /* webpackChunkName: "pages/promote" */))
const _47dfb8c5 = () => interopDefault(import('../../../pages/settings/index.vue' /* webpackChunkName: "pages/settings/index" */))
const _20fa871f = () => interopDefault(import('../../../pages/shortlinks/index.vue' /* webpackChunkName: "pages/shortlinks/index" */))
const _329edf78 = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _6c97c85c = () => interopDefault(import('../../../pages/unsubscribed.vue' /* webpackChunkName: "pages/unsubscribed" */))
const _3c6450ac = () => interopDefault(import('../../../pages/visualise.vue' /* webpackChunkName: "pages/visualise" */))
const _2720ad14 = () => interopDefault(import('../../../pages/voteforfreegle.vue' /* webpackChunkName: "pages/voteforfreegle" */))
const _0a61a608 = () => interopDefault(import('../../../pages/yahoologin.vue' /* webpackChunkName: "pages/yahoologin" */))
const _1ada8cc9 = () => interopDefault(import('../../../pages/councils/banners.vue' /* webpackChunkName: "pages/councils/banners" */))
const _57fbdce6 = () => interopDefault(import('../../../pages/councils/bestpractice.vue' /* webpackChunkName: "pages/councils/bestpractice" */))
const _840c387e = () => interopDefault(import('../../../pages/councils/bulkywaste.vue' /* webpackChunkName: "pages/councils/bulkywaste" */))
const _df53ffb6 = () => interopDefault(import('../../../pages/councils/businesscards.vue' /* webpackChunkName: "pages/councils/businesscards" */))
const _584a2ea4 = () => interopDefault(import('../../../pages/councils/climate-emergency/index.vue' /* webpackChunkName: "pages/councils/climate-emergency/index" */))
const _07d058af = () => interopDefault(import('../../../pages/councils/giveandtake.vue' /* webpackChunkName: "pages/councils/giveandtake" */))
const _4ed6cdf9 = () => interopDefault(import('../../../pages/councils/graphics.vue' /* webpackChunkName: "pages/councils/graphics" */))
const _1c4f6eb0 = () => interopDefault(import('../../../pages/councils/keylinks.vue' /* webpackChunkName: "pages/councils/keylinks" */))
const _036a6604 = () => interopDefault(import('../../../pages/councils/othercouncils.vue' /* webpackChunkName: "pages/councils/othercouncils" */))
const _e8d02c32 = () => interopDefault(import('../../../pages/councils/overview.vue' /* webpackChunkName: "pages/councils/overview" */))
const _f7021ef2 = () => interopDefault(import('../../../pages/councils/photosvideos.vue' /* webpackChunkName: "pages/councils/photosvideos" */))
const _20048970 = () => interopDefault(import('../../../pages/councils/posters.vue' /* webpackChunkName: "pages/councils/posters" */))
const _23ed935c = () => interopDefault(import('../../../pages/councils/pressrelease.vue' /* webpackChunkName: "pages/councils/pressrelease" */))
const _40e742d5 = () => interopDefault(import('../../../pages/councils/socialhousing/index.vue' /* webpackChunkName: "pages/councils/socialhousing/index" */))
const _71e5a4ce = () => interopDefault(import('../../../pages/councils/socialmedia.vue' /* webpackChunkName: "pages/councils/socialmedia" */))
const _10b0e055 = () => interopDefault(import('../../../pages/councils/stories.vue' /* webpackChunkName: "pages/councils/stories" */))
const _197e5d17 = () => interopDefault(import('../../../pages/councils/volunteers.vue' /* webpackChunkName: "pages/councils/volunteers" */))
const _8994e36c = () => interopDefault(import('../../../pages/councils/why.vue' /* webpackChunkName: "pages/councils/why" */))
const _37490ae3 = () => interopDefault(import('../../../pages/councils/workbest.vue' /* webpackChunkName: "pages/councils/workbest" */))
const _52546d7d = () => interopDefault(import('../../../pages/find/whereami.vue' /* webpackChunkName: "pages/find/whereami" */))
const _8d73c2f4 = () => interopDefault(import('../../../pages/find/whoami.vue' /* webpackChunkName: "pages/find/whoami" */))
const _53b76725 = () => interopDefault(import('../../../pages/give/whereami.vue' /* webpackChunkName: "pages/give/whereami" */))
const _e2293ba4 = () => interopDefault(import('../../../pages/give/whoami.vue' /* webpackChunkName: "pages/give/whoami" */))
const _2ae63eeb = () => interopDefault(import('../../../pages/modtools/admins.vue' /* webpackChunkName: "pages/modtools/admins" */))
const _1f91b135 = () => interopDefault(import('../../../pages/modtools/giftaid.vue' /* webpackChunkName: "pages/modtools/giftaid" */))
const _62a0d7d6 = () => interopDefault(import('../../../pages/modtools/logs.vue' /* webpackChunkName: "pages/modtools/logs" */))
const _045807e4 = () => interopDefault(import('../../../pages/modtools/publicity.vue' /* webpackChunkName: "pages/modtools/publicity" */))
const _40db041f = () => interopDefault(import('../../../pages/modtools/teams.vue' /* webpackChunkName: "pages/modtools/teams" */))
const _c24f9dbc = () => interopDefault(import('../../../pages/stats/authorities.vue' /* webpackChunkName: "pages/stats/authorities" */))
const _7f222e6d = () => interopDefault(import('../../../pages/stats/heatmap.vue' /* webpackChunkName: "pages/stats/heatmap" */))
const _28726df7 = () => interopDefault(import('../../../pages/stories/fornewsletter.vue' /* webpackChunkName: "pages/stories/fornewsletter" */))
const _2093fc0d = () => interopDefault(import('../../../pages/councils/casestudies/cumbria.vue' /* webpackChunkName: "pages/councils/casestudies/cumbria" */))
const _7e3face2 = () => interopDefault(import('../../../pages/councils/casestudies/essex.vue' /* webpackChunkName: "pages/councils/casestudies/essex" */))
const _43ab30c7 = () => interopDefault(import('../../../pages/councils/casestudies/sutton.vue' /* webpackChunkName: "pages/councils/casestudies/sutton" */))
const _c1e80f1a = () => interopDefault(import('../../../pages/modtools/chats/review.vue' /* webpackChunkName: "pages/modtools/chats/review" */))
const _b4248154 = () => interopDefault(import('../../../pages/modtools/members/newsletter.vue' /* webpackChunkName: "pages/modtools/members/newsletter" */))
const _10cd5616 = () => interopDefault(import('../../../pages/modtools/members/review.vue' /* webpackChunkName: "pages/modtools/members/review" */))
const _325c7b06 = () => interopDefault(import('../../../pages/modtools/members/stories.vue' /* webpackChunkName: "pages/modtools/members/stories" */))
const _1438696f = () => interopDefault(import('../../../pages/modtools/members/approved/search/_term.vue' /* webpackChunkName: "pages/modtools/members/approved/search/_term" */))
const _1da84d4c = () => interopDefault(import('../../../pages/modtools/members/approved/search/_id/_term.vue' /* webpackChunkName: "pages/modtools/members/approved/search/_id/_term" */))
const _2097b33f = () => interopDefault(import('../../../pages/modtools/members/approved/_id.vue' /* webpackChunkName: "pages/modtools/members/approved/_id" */))
const _76d58a0d = () => interopDefault(import('../../../pages/modtools/members/feedback/_id.vue' /* webpackChunkName: "pages/modtools/members/feedback/_id" */))
const _c80b310c = () => interopDefault(import('../../../pages/modtools/members/microvolunteering/_id.vue' /* webpackChunkName: "pages/modtools/members/microvolunteering/_id" */))
const _3cc07e42 = () => interopDefault(import('../../../pages/modtools/members/notes/_id.vue' /* webpackChunkName: "pages/modtools/members/notes/_id" */))
const _63448cee = () => interopDefault(import('../../../pages/modtools/members/related/_id.vue' /* webpackChunkName: "pages/modtools/members/related/_id" */))
const _5287072e = () => interopDefault(import('../../../pages/modtools/messages/approved/_id.vue' /* webpackChunkName: "pages/modtools/messages/approved/_id" */))
const _2f942838 = () => interopDefault(import('../../../pages/modtools/messages/edits/_id.vue' /* webpackChunkName: "pages/modtools/messages/edits/_id" */))
const _483f6d26 = () => interopDefault(import('../../../pages/modtools/messages/pending/_id.vue' /* webpackChunkName: "pages/modtools/messages/pending/_id" */))
const _051fefd4 = () => interopDefault(import('../../../pages/modtools/support/refer/_id.vue' /* webpackChunkName: "pages/modtools/support/refer/_id" */))
const _0946323e = () => interopDefault(import('../../../pages/alert/viewed/_id.vue' /* webpackChunkName: "pages/alert/viewed/_id" */))
const _0b0e9620 = () => interopDefault(import('../../../pages/explore/join/_id.vue' /* webpackChunkName: "pages/explore/join/_id" */))
const _1b857ad6 = () => interopDefault(import('../../../pages/explore/location/_location.vue' /* webpackChunkName: "pages/explore/location/_location" */))
const _9d1c86aa = () => interopDefault(import('../../../pages/explore/place/_place.vue' /* webpackChunkName: "pages/explore/place/_place" */))
const _d497b3d4 = () => interopDefault(import('../../../pages/explore/region/_region/index.vue' /* webpackChunkName: "pages/explore/region/_region/index" */))
const _1691c3af = () => interopDefault(import('../../../pages/modtools/chats/_id.vue' /* webpackChunkName: "pages/modtools/chats/_id" */))
const _18febcd4 = () => interopDefault(import('../../../pages/modtools/communityevents/_id.vue' /* webpackChunkName: "pages/modtools/communityevents/_id" */))
const _811d34d6 = () => interopDefault(import('../../../pages/modtools/map/_groupid.vue' /* webpackChunkName: "pages/modtools/map/_groupid" */))
const _d15e214a = () => interopDefault(import('../../../pages/modtools/message/_id.vue' /* webpackChunkName: "pages/modtools/message/_id" */))
const _f15da516 = () => interopDefault(import('../../../pages/modtools/settings/_id.vue' /* webpackChunkName: "pages/modtools/settings/_id" */))
const _197676fe = () => interopDefault(import('../../../pages/modtools/spammers/_search.vue' /* webpackChunkName: "pages/modtools/spammers/_search" */))
const _41602723 = () => interopDefault(import('../../../pages/modtools/support/_id.vue' /* webpackChunkName: "pages/modtools/support/_id" */))
const _fee4f62c = () => interopDefault(import('../../../pages/modtools/volunteering/_id.vue' /* webpackChunkName: "pages/modtools/volunteering/_id" */))
const _37dc0d95 = () => interopDefault(import('../../../pages/settings/confirmmail/_key.vue' /* webpackChunkName: "pages/settings/confirmmail/_key" */))
const _3428d3a2 = () => interopDefault(import('../../../pages/stats/authority/_id.vue' /* webpackChunkName: "pages/stats/authority/_id" */))
const _f0346aba = () => interopDefault(import('../../../pages/stories/authority/_id.vue' /* webpackChunkName: "pages/stories/authority/_id" */))
const _9994b7b6 = () => interopDefault(import('../../../pages/browse/_term.vue' /* webpackChunkName: "pages/browse/_term" */))
const _c2b32892 = () => interopDefault(import('../../../pages/chats/_id.vue' /* webpackChunkName: "pages/chats/_id" */))
const _5bdcd21c = () => interopDefault(import('../../../pages/chitchat/_id.vue' /* webpackChunkName: "pages/chitchat/_id" */))
const _1b3f895b = () => interopDefault(import('../../../pages/communityevent/_id.vue' /* webpackChunkName: "pages/communityevent/_id" */))
const _2f08df9e = () => interopDefault(import('../../../pages/communityevents/_id.vue' /* webpackChunkName: "pages/communityevents/_id" */))
const _03bb63ef = () => interopDefault(import('../../../pages/explore/_id.vue' /* webpackChunkName: "pages/explore/_id" */))
const _6f81fa0d = () => interopDefault(import('../../../pages/handover/_id.vue' /* webpackChunkName: "pages/handover/_id" */))
const _d5cfa0ce = () => interopDefault(import('../../../pages/job/_id.vue' /* webpackChunkName: "pages/job/_id" */))
const _6cdbb563 = () => interopDefault(import('../../../pages/message/_id.vue' /* webpackChunkName: "pages/message/_id" */))
const _75f971ef = () => interopDefault(import('../../../pages/noticeboards/_id.vue' /* webpackChunkName: "pages/noticeboards/_id" */))
const _9ee89552 = () => interopDefault(import('../../../pages/poster/_id.vue' /* webpackChunkName: "pages/poster/_id" */))
const _41347d05 = () => interopDefault(import('../../../pages/profile/_id.vue' /* webpackChunkName: "pages/profile/_id" */))
const _157a6adc = () => interopDefault(import('../../../pages/shortlink/_id.vue' /* webpackChunkName: "pages/shortlink/_id" */))
const _d5247572 = () => interopDefault(import('../../../pages/shortlinks/_id.vue' /* webpackChunkName: "pages/shortlinks/_id" */))
const _2d5c441a = () => interopDefault(import('../../../pages/stats/_groupname.vue' /* webpackChunkName: "pages/stats/_groupname" */))
const _28919376 = () => interopDefault(import('../../../pages/stories/_groupid.vue' /* webpackChunkName: "pages/stories/_groupid" */))
const _ce97dade = () => interopDefault(import('../../../pages/story/_id.vue' /* webpackChunkName: "pages/story/_id" */))
const _04a27ca6 = () => interopDefault(import('../../../pages/unsubscribe/_id.vue' /* webpackChunkName: "pages/unsubscribe/_id" */))
const _7e7543e2 = () => interopDefault(import('../../../pages/volunteering/_id.vue' /* webpackChunkName: "pages/volunteering/_id" */))
const _328a75f7 = () => interopDefault(import('../../../pages/volunteerings/_id.vue' /* webpackChunkName: "pages/volunteerings/_id" */))
const _69c0b0f7 = () => interopDefault(import('../../../pages/what-to-do-with-an-old/_item.vue' /* webpackChunkName: "pages/what-to-do-with-an-old/_item" */))
const _f91e66f4 = () => interopDefault(import('../../../pages/explore/_groupid/_msgid.vue' /* webpackChunkName: "pages/explore/_groupid/_msgid" */))
const _3caac09c = () => interopDefault(import('../../../pages/mypost/_id/_action.vue' /* webpackChunkName: "pages/mypost/_id/_action" */))
const _eebdbd7a = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _68e9467e,
    name: "about"
  }, {
    path: "/councils",
    component: _1e8803d4,
    name: "councils"
  }, {
    path: "/disclaimer",
    component: _462f790c,
    name: "disclaimer"
  }, {
    path: "/discourse",
    component: _2e76bacc,
    name: "discourse"
  }, {
    path: "/donate",
    component: _dcc3ec64,
    name: "donate"
  }, {
    path: "/donated",
    component: _b6091ef4,
    name: "donated"
  }, {
    path: "/donations-this-month",
    component: _f5452e48,
    name: "donations-this-month"
  }, {
    path: "/engage",
    component: _044bd1c0,
    name: "engage"
  }, {
    path: "/find",
    component: _b153ab4a,
    name: "find"
  }, {
    path: "/forgot",
    component: _4f662882,
    name: "forgot"
  }, {
    path: "/forum",
    component: _32fec612,
    name: "forum"
  }, {
    path: "/giftaid",
    component: _517e8986,
    name: "giftaid"
  }, {
    path: "/give",
    component: _5ba5d1b3,
    name: "give"
  }, {
    path: "/help",
    component: _62df8940,
    name: "help"
  }, {
    path: "/how-it-works",
    component: _1318505c,
    name: "how-it-works"
  }, {
    path: "/isochrones",
    component: _2435d9b4,
    name: "isochrones"
  }, {
    path: "/jobs",
    component: _c32a9416,
    name: "jobs"
  }, {
    path: "/livemap",
    component: _5b9aa421,
    name: "livemap"
  }, {
    path: "/maintenance",
    component: _21e59c44,
    name: "maintenance"
  }, {
    path: "/merge",
    component: _19bd79a9,
    name: "merge"
  }, {
    path: "/mobile",
    component: _39a002fe,
    name: "mobile"
  }, {
    path: "/modtools",
    component: _1a27353b,
    name: "modtools"
  }, {
    path: "/mydata",
    component: _38498996,
    name: "mydata"
  }, {
    path: "/myposts",
    component: _28434d58,
    name: "myposts"
  }, {
    path: "/norfolk",
    component: _5b911dec,
    name: "norfolk"
  }, {
    path: "/privacy",
    component: _2d5a7eb9,
    name: "privacy"
  }, {
    path: "/promote",
    component: _008a4ef1,
    name: "promote"
  }, {
    path: "/settings",
    component: _47dfb8c5,
    name: "settings"
  }, {
    path: "/shortlinks",
    component: _20fa871f,
    name: "shortlinks"
  }, {
    path: "/terms",
    component: _329edf78,
    name: "terms"
  }, {
    path: "/unsubscribed",
    component: _6c97c85c,
    name: "unsubscribed"
  }, {
    path: "/visualise",
    component: _3c6450ac,
    name: "visualise"
  }, {
    path: "/voteforfreegle",
    component: _2720ad14,
    name: "voteforfreegle"
  }, {
    path: "/yahoologin",
    component: _0a61a608,
    name: "yahoologin"
  }, {
    path: "/councils/banners",
    component: _1ada8cc9,
    name: "councils-banners"
  }, {
    path: "/councils/bestpractice",
    component: _57fbdce6,
    name: "councils-bestpractice"
  }, {
    path: "/councils/bulkywaste",
    component: _840c387e,
    name: "councils-bulkywaste"
  }, {
    path: "/councils/businesscards",
    component: _df53ffb6,
    name: "councils-businesscards"
  }, {
    path: "/councils/climate-emergency",
    component: _584a2ea4,
    name: "councils-climate-emergency"
  }, {
    path: "/councils/giveandtake",
    component: _07d058af,
    name: "councils-giveandtake"
  }, {
    path: "/councils/graphics",
    component: _4ed6cdf9,
    name: "councils-graphics"
  }, {
    path: "/councils/keylinks",
    component: _1c4f6eb0,
    name: "councils-keylinks"
  }, {
    path: "/councils/othercouncils",
    component: _036a6604,
    name: "councils-othercouncils"
  }, {
    path: "/councils/overview",
    component: _e8d02c32,
    name: "councils-overview"
  }, {
    path: "/councils/photosvideos",
    component: _f7021ef2,
    name: "councils-photosvideos"
  }, {
    path: "/councils/posters",
    component: _20048970,
    name: "councils-posters"
  }, {
    path: "/councils/pressrelease",
    component: _23ed935c,
    name: "councils-pressrelease"
  }, {
    path: "/councils/socialhousing",
    component: _40e742d5,
    name: "councils-socialhousing"
  }, {
    path: "/councils/socialmedia",
    component: _71e5a4ce,
    name: "councils-socialmedia"
  }, {
    path: "/councils/stories",
    component: _10b0e055,
    name: "councils-stories"
  }, {
    path: "/councils/volunteers",
    component: _197e5d17,
    name: "councils-volunteers"
  }, {
    path: "/councils/why",
    component: _8994e36c,
    name: "councils-why"
  }, {
    path: "/councils/workbest",
    component: _37490ae3,
    name: "councils-workbest"
  }, {
    path: "/find/whereami",
    component: _52546d7d,
    name: "find-whereami"
  }, {
    path: "/find/whoami",
    component: _8d73c2f4,
    name: "find-whoami"
  }, {
    path: "/give/whereami",
    component: _53b76725,
    name: "give-whereami"
  }, {
    path: "/give/whoami",
    component: _e2293ba4,
    name: "give-whoami"
  }, {
    path: "/modtools/admins",
    component: _2ae63eeb,
    name: "modtools-admins"
  }, {
    path: "/modtools/giftaid",
    component: _1f91b135,
    name: "modtools-giftaid"
  }, {
    path: "/modtools/logs",
    component: _62a0d7d6,
    name: "modtools-logs"
  }, {
    path: "/modtools/publicity",
    component: _045807e4,
    name: "modtools-publicity"
  }, {
    path: "/modtools/teams",
    component: _40db041f,
    name: "modtools-teams"
  }, {
    path: "/stats/authorities",
    component: _c24f9dbc,
    name: "stats-authorities"
  }, {
    path: "/stats/heatmap",
    component: _7f222e6d,
    name: "stats-heatmap"
  }, {
    path: "/stories/fornewsletter",
    component: _28726df7,
    name: "stories-fornewsletter"
  }, {
    path: "/councils/casestudies/cumbria",
    component: _2093fc0d,
    name: "councils-casestudies-cumbria"
  }, {
    path: "/councils/casestudies/essex",
    component: _7e3face2,
    name: "councils-casestudies-essex"
  }, {
    path: "/councils/casestudies/sutton",
    component: _43ab30c7,
    name: "councils-casestudies-sutton"
  }, {
    path: "/modtools/chats/review",
    component: _c1e80f1a,
    name: "modtools-chats-review"
  }, {
    path: "/modtools/members/newsletter",
    component: _b4248154,
    name: "modtools-members-newsletter"
  }, {
    path: "/modtools/members/review",
    component: _10cd5616,
    name: "modtools-members-review"
  }, {
    path: "/modtools/members/stories",
    component: _325c7b06,
    name: "modtools-members-stories"
  }, {
    path: "/modtools/members/approved/search/:term?",
    component: _1438696f,
    name: "modtools-members-approved-search-term"
  }, {
    path: "/modtools/members/approved/search/:id?/:term?",
    component: _1da84d4c,
    name: "modtools-members-approved-search-id-term"
  }, {
    path: "/modtools/members/approved/:id?",
    component: _2097b33f,
    name: "modtools-members-approved-id"
  }, {
    path: "/modtools/members/feedback/:id?",
    component: _76d58a0d,
    name: "modtools-members-feedback-id"
  }, {
    path: "/modtools/members/microvolunteering/:id?",
    component: _c80b310c,
    name: "modtools-members-microvolunteering-id"
  }, {
    path: "/modtools/members/notes/:id?",
    component: _3cc07e42,
    name: "modtools-members-notes-id"
  }, {
    path: "/modtools/members/related/:id?",
    component: _63448cee,
    name: "modtools-members-related-id"
  }, {
    path: "/modtools/messages/approved/:id?",
    component: _5287072e,
    name: "modtools-messages-approved-id"
  }, {
    path: "/modtools/messages/edits/:id?",
    component: _2f942838,
    name: "modtools-messages-edits-id"
  }, {
    path: "/modtools/messages/pending/:id?",
    component: _483f6d26,
    name: "modtools-messages-pending-id"
  }, {
    path: "/modtools/support/refer/:id?",
    component: _051fefd4,
    name: "modtools-support-refer-id"
  }, {
    path: "/alert/viewed/:id?",
    component: _0946323e,
    name: "alert-viewed-id"
  }, {
    path: "/explore/join/:id?",
    component: _0b0e9620,
    name: "explore-join-id"
  }, {
    path: "/explore/location/:location?",
    component: _1b857ad6,
    name: "explore-location-location"
  }, {
    path: "/explore/place/:place?",
    component: _9d1c86aa,
    name: "explore-place-place"
  }, {
    path: "/explore/region/:region",
    component: _d497b3d4,
    name: "explore-region-region"
  }, {
    path: "/modtools/chats/:id?",
    component: _1691c3af,
    name: "modtools-chats-id"
  }, {
    path: "/modtools/communityevents/:id?",
    component: _18febcd4,
    name: "modtools-communityevents-id"
  }, {
    path: "/modtools/map/:groupid?",
    component: _811d34d6,
    name: "modtools-map-groupid"
  }, {
    path: "/modtools/message/:id?",
    component: _d15e214a,
    name: "modtools-message-id"
  }, {
    path: "/modtools/settings/:id?",
    component: _f15da516,
    name: "modtools-settings-id"
  }, {
    path: "/modtools/spammers/:search?",
    component: _197676fe,
    name: "modtools-spammers-search"
  }, {
    path: "/modtools/support/:id?",
    component: _41602723,
    name: "modtools-support-id"
  }, {
    path: "/modtools/volunteering/:id?",
    component: _fee4f62c,
    name: "modtools-volunteering-id"
  }, {
    path: "/settings/confirmmail/:key?",
    component: _37dc0d95,
    name: "settings-confirmmail-key"
  }, {
    path: "/stats/authority/:id?",
    component: _3428d3a2,
    name: "stats-authority-id"
  }, {
    path: "/stories/authority/:id?",
    component: _f0346aba,
    name: "stories-authority-id"
  }, {
    path: "/browse/:term?",
    component: _9994b7b6,
    name: "browse-term"
  }, {
    path: "/chats/:id?",
    component: _c2b32892,
    name: "chats-id"
  }, {
    path: "/chitchat/:id?",
    component: _5bdcd21c,
    name: "chitchat-id"
  }, {
    path: "/communityevent/:id?",
    component: _1b3f895b,
    name: "communityevent-id"
  }, {
    path: "/communityevents/:id?",
    component: _2f08df9e,
    name: "communityevents-id"
  }, {
    path: "/explore/:id?",
    component: _03bb63ef,
    name: "explore-id"
  }, {
    path: "/handover/:id?",
    component: _6f81fa0d,
    name: "handover-id"
  }, {
    path: "/job/:id?",
    component: _d5cfa0ce,
    name: "job-id"
  }, {
    path: "/message/:id?",
    component: _6cdbb563,
    name: "message-id"
  }, {
    path: "/noticeboards/:id?",
    component: _75f971ef,
    name: "noticeboards-id"
  }, {
    path: "/poster/:id?",
    component: _9ee89552,
    name: "poster-id"
  }, {
    path: "/profile/:id?",
    component: _41347d05,
    name: "profile-id"
  }, {
    path: "/shortlink/:id?",
    component: _157a6adc,
    name: "shortlink-id"
  }, {
    path: "/shortlinks/:id",
    component: _d5247572,
    name: "shortlinks-id"
  }, {
    path: "/stats/:groupname?",
    component: _2d5c441a,
    name: "stats-groupname"
  }, {
    path: "/stories/:groupid?",
    component: _28919376,
    name: "stories-groupid"
  }, {
    path: "/story/:id?",
    component: _ce97dade,
    name: "story-id"
  }, {
    path: "/unsubscribe/:id?",
    component: _04a27ca6,
    name: "unsubscribe-id"
  }, {
    path: "/volunteering/:id?",
    component: _7e7543e2,
    name: "volunteering-id"
  }, {
    path: "/volunteerings/:id?",
    component: _328a75f7,
    name: "volunteerings-id"
  }, {
    path: "/what-to-do-with-an-old/:item?",
    component: _69c0b0f7,
    name: "what-to-do-with-an-old-item"
  }, {
    path: "/explore/:groupid?/:msgid?",
    component: _f91e66f4,
    name: "explore-groupid-msgid"
  }, {
    path: "/mypost/:id?/:action?",
    component: _3caac09c,
    name: "mypost-id-action"
  }, {
    path: "/",
    component: _eebdbd7a,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
